import Vue from 'vue';
import ProductSourceDialog from './components/dialog';

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^e-/, /^pp-/];

export const renderProductSourceDialog = async function(rootElement) {
  return new Vue({
    render: h => h(ProductSourceDialog)
  }).$mount(rootElement);
};
